import React, { useEffect, useState } from "react";
import { Link,useHistory } from "react-router-dom";
const initialState = {
  email: "",
  password: "",
  isError: false,
  responseMessage: "",
};
const SiteBanner = () => {
  const [formState, setFormState] = useState(initialState);
  const handlePageState = (newStates: any) => {
    setFormState((prevStates) => {
      return {
        ...prevStates,
        ...newStates,
      };
    });
  };
  useEffect(() => {
    $("#login_modal").modal("hide");
    $(".showActive").addClass("hide");
    const queryParams = new URLSearchParams(window.location.search);
    const type = queryParams.get("type");
    if(type==null){
      $("#login_modal").modal("hide");
      $(".showActive").addClass("hide");
    }else{
      if(type=='Activate'){
        $("#login_modal").modal("show");
        $(".showActive").removeClass("hide");
      }if(type=='Login'){
        $("#login_modal").modal("show");
      }else{
        $("#login_modal").modal("show");
      }
      
    }
  });
  
  return (
    <>
      <section className="site-banner">
        <div className="container">
          <div className="row banner-content align-items-center">
            <div className="col-md-7">
              <div className="content">
                <h1>The smart way to find your mortgage adviser</h1>
                <p>
                   Five advisers compete to secure you the best deal possible. 100% free to use - save time, save hassle, and see if you can save money too.
                </p>
                <Link
                    to={`/need`}
                    className="btn-white btn-expert text-uppercase page-scroll"
                  >
                    Find your Adviser
                  </Link>
                {/* <a
                  href={`/need`}
                  className="btn-white btn-expert text-uppercase page-scroll"
                >
                  Find your Adviser
                </a> */}
              </div>
            </div>
            <div className="col-md-5 text-center">
              <div className="img">
                <a href="/chat-gpt">
                <img
                  src="assets/images/question.png"
                  alt="banner-img"
                  className="img-fluid w-100"
                /></a>
              </div>
              <div className="button-bnnar">
                <a href="/chat-gpt">Get quick answers to your mortgage questions by chatting with Einstein, our chatGPT-powered mortgage bot.</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="three-boxes-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-6">
              <div className="boxes box-1">
                <div className="row">
                  <div className="col-3">
                    <div className="box-img text-right">
                      <img
                        src="assets/images/time-icon.png"
                        alt="time"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="col-9">
                    <h6 className="text-uppercase">Quick and Easy</h6>
                    <p>
                      In less than 60 seconds we can put you in touch with five
                      mortgage advisers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="boxes">
                <div className="row">
                  <div className="col-3">
                    <div className="box-img text-right">
                      <img
                        src="assets/images/seo-icon.png"
                        alt="seo"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="col-9">
                    <h6 className="text-uppercase">Tailored advice</h6>
                    <p>
                      Expert advisers are matched to your unique mortgage need
                      giving you more choice and higher acceptance rates.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="boxes">
                <div className="row">
                  <div className="col-3">
                    <div className="box-img text-right">
                      <img
                        src="assets/images/hand-icon.png"
                        alt="hand"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="col-9">
                    <h6 className="text-uppercase">Save money</h6>
                    <p>
                      Don’t just talk to one adviser for such a big decision.
                      Make sure you secure the best possible deal, and our
                      service won't cost you a penny.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="help-you-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 text-center">
              <div className="heading">
                <h2 className="text-uppercase">HOW MORTGAGEBOX WORKS</h2>
                <p>
                  80% of people use a mortgage adviser but most only speak to
                  one.
                </p>
                <span></span>
              </div>
            </div>
          </div>
          <div className="row help-boxes text-center">
            <div className="col-xl-4 col-lg-6">
              <div className="help-box">
                <div className="box-img">
                  <img
                    src="assets/images/help-1.png"
                    alt="help-1"
                    className="img-fluid"
                  />
                </div>
                <h6>Outline your Mortgage need</h6>
                <span></span>
                <p>
                  Answer a few questions in under 60 seconds and we’ll match you
                  with five FCA regulated Mortgage Advisers.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6">
              <div className="help-box">
                <div className="box-img">
                  <img
                    src="assets/images/help-2.png"
                    alt="help-2"
                    className="img-fluid"
                  />
                </div>
                <h6>Compare your advisers</h6>
                <span></span>
                <p>
                  Chat, message and speak to the mortgage experts. Compare their
                  advice, deals, incentives and ratings.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6">
              <div className="help-box">
                <div className="box-img">
                  <img
                    src="assets/images/help-3.png"
                    alt="help-3"
                    className="img-fluid"
                  />
                </div>
                <h6>Relax</h6>
                <span></span>
                <p>
                  Your preferred adviser will take care of your application from
                  start to finish - taking away the stress and hassle.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="box-different-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 text-center">
              <div className="heading">
                <h2 className="text-uppercase">FEATURES DESIGNED AROUND YOU</h2>
                <p>
                  The best way to find your perfect mortgage adviser who puts
                  your interests first
                </p>
                <span></span>
              </div>
            </div>
          </div>
          <div className="row different-boxes">
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
              <div className="different-box">
                <div className="box-img">
                  <img
                    src="assets/images/offer.png"
                    alt="offer"
                    className="img-fluid"
                  />
                </div>
                <h6>Choice of advisers offering you deals</h6>
                <span></span>
                <p>
                  Five expert mortgage advisers compete for your business.
                  Compare their offers, advice and incentives and select the one
                  right for you.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-lg-6 col-md-6 col-sm-6">
              <div className="different-box">
                <div className="box-img">
                  <img
                    src="assets/images/briefcase.png"
                    alt="briefcase"
                    className="img-fluid"
                  />
                </div>
                <h6>Not just standard mortgages</h6>
                <span></span>
                <p>
                  Need a non-standard mortgage? We have specialised advisers
                  covering just about every possible borrowing need from retail
                  to commercial.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-lg-6 col-md-6 col-sm-6">
              <div className="different-box">
                <div className="box-img">
                  <img
                    src="assets/images/save-money.png"
                    alt="save-money"
                    className="img-fluid"
                  />
                </div>
                <h6>Awesome savings</h6>
                <span></span>
                <p>
                  Save time, save hassle, and see if you can save money. It pays to connect to more than one adviser.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-lg-6 col-md-6 col-sm-6">
              <div className="different-box">
                <div className="box-img">
                  <img
                    src="assets/images/bulb.png"
                    alt="translate"
                    className="img-fluid"
                  />
                </div>
                <h6>The advisers come to you</h6>
                <span></span>
                <p>
                  No need to spend hours on Google - enter your mortgage needs
                  just once and let matched advisers come to you.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-lg-6 col-md-6 col-sm-6">
              <div className="different-box">
                <div className="box-img">
                  <img
                    src="assets/images/no.png"
                    alt="no"
                    className="img-fluid"
                  />
                </div>
                <h6>Adviser fees</h6>
                <span></span>
                <p>
                  Certain advisers may charge fees. Choose whether to notify advisers if you prefer not to pay a fee.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-lg-6 col-md-6 col-sm-6">
              <div className="different-box">
                <div className="box-img">
                  <img
                    src="assets/images/time.png"
                    alt="time"
                    className="img-fluid"
                  />
                </div>
                <h6>Safe & Secure</h6>
                <span></span>
                <p>
                  Our built in messaging app keeps everything in one place and
                  your details private. You choose if and when to provide
                  additional contact information.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="testimonial-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <div className="heading">
                  <h2 className="text-uppercase">Why use Mortgagebox?</h2>
                  <p>
                      Representative feedback received
                  </p>
                  <span></span>
                </div>
              </div>
            </div>
            <div className="row testmonial-slider">
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>To save money</span> <br />
                    Mortgagebox is such a great idea, no more scurrying around
                    hunting for the right adviser
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/user.png"
                      alt="testi"
                      className="img-fluid"
                    />
                    <h5 className="text-uppercase">john</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>
                      Have a choice of mortgage advisers matched to my needs.
                    </span>{" "}
                    <br />
                      Mortgagebox saved me so much times
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/testi-icon-2.png"
                      alt="testi"
                      className="img-fluid"
                    />
                    <h5 className="text-uppercase">Maria</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>
                      Keep control of who sees my personal details
                    </span>{" "}
                    <br />
                      Found the perfect adviser who kept me in the loop the whole way through, I recommend it to everyone
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/testi-icon-3.png"
                      alt="testi"
                      className="img-fluid image-icon-testimonial"
                    />
                    <h5 className="text-uppercase">Michael</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>No long application form to complete</span> <br />
                    We found our mortgage adviser in less than 12 hours
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/testi-icon-4.png"
                      alt="testi"
                      className="img-fluid"
                    />
                    <h5 className="text-uppercase">Davis</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>
                      Make at least one part of moving house stress free
                    </span>{" "}
                    <br />
                    My adviser made the whole process easy and stress free
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/testi-icon-5.png"
                      alt="testi"
                      className="img-fluid image-icon-testimonial"
                    />
                    <h5 className="text-uppercase">Thomas</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>It’s quick and simple and I’m in control</span> <br />
                    I tried going directly to banks, but the questions they
                    asked needed a degree in finance to answer. I then decided
                    to try Mortgagebox, best decision I could have made!
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/user.png"
                      alt="testi"
                      className="img-fluid"
                    />
                    <h5 className="text-uppercase">Hannah</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>Not all my eggs in one basket</span> <br />I needed a
                    specialised loan which only a few brokers deal in. Without
                    Mortgagebox I’m would definitely have struggled to find the
                    right adviser
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/testi-icon-11.png"
                      alt="testi"
                      className="img-fluid"
                    />
                    <h5 className="text-uppercase">Anant</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>
                      I need a specialised loan which only a few brokers deal
                      in.
                    </span>{" "}
                    <br />
                    Wish we had found mortgagebox first time round. Initially we
                    used a mortgage comparison site, which after asking loads of
                    questions simply redirected us to another mortgage site.
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/testi-icon-8.png"
                      alt="testi"
                      className="img-fluid image-icon-testimonial"
                    />
                    <h5 className="text-uppercase">peter</h5>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 text-center">
                <div className="testi-box">
                  <div className="box-img">
                    <img
                      src="assets/images/quote-img.png"
                      alt="quote"
                      className="img-fluid"
                    />
                  </div>
                  <p>
                    <br />
                    <span>
                      To find real mortgage advisers who actually talk my
                      language
                    </span>{" "}
                    <br />
                    Cracking site. Had five advisers contact me, two looked
                    really good before I whittled it down to one, who has proved
                    really good
                  </p>
                  <div className="client-details">
                    <img
                      src="assets/images/testi-icon-10.png"
                      alt="testi"
                      className="img-fluid"
                    />
                    <h5 className="text-uppercase">Afram</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="we-belive-section">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1 text-center">
              <div className="belive-content">
                <h2>It pays to connect to more than one adviser</h2>
                <ul className="ml-0">
                  <li>More options</li>
                  <li>Better deals</li>
                  <li>Higher acceptance rate</li>
                  <li>Painless to be connected</li>
                  <li>You choose which ones you want to talk to</li>
                  <li>
                    Plenty of thinking time to review offers and compare them
                  </li>
                  <li>Not all mortgage advisers are the same</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SiteBanner;
